import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import(/* webpackChunkName: 'sb-style.ProductGallery', webpackPrefetch: true */ './style.scss');
import { useCallback, useEffect, useMemo, useRef } from 'react';
import ProductGalleryFiltersSection from './filter-section';
import ProductGalleryRoomsSection from './rooms-section';
import ProductGalleryGallerySection from './gallery-section';
import { useCommonReducer } from '@components/Shared/State/hooks';
import jQuery from 'jquery';
import clsx from 'clsx';
import useMediaQuery from '@mui/material/useMediaQuery';
import { styled, useTheme } from '@mui/material/styles';
import AppProvider from '@components/Shared/State/provider';
import SbThemeProvider from '@components/theme/provider';
import Drawer from '@mui/material/Drawer';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ZoomProductGalleryGallerySection from './zoom-gallery-section';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { createRoot } from 'react-dom/client';
import ProductCardItem from './productCardItem';
import { DistinctFrom } from '@commons/helpers';
const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    justifyContent: 'flex-end',
    position: 'absolute',
    right: 10,
    top: 10,
}));
// Adding this component for screen reader only text
const ScreenReaderOnly = styled('span')({
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: '0',
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    borderWidth: '0',
});
function ProductGallery({ heading, data: { product_gallery_items } }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const mainSwiperElement = useRef(null);
    const zoomSwiperElement = useRef(null);
    const rootElement = useRef(null);
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down(1050));
    const desktop = useMediaQuery(theme.breakpoints.up(1050));
    const items = useMemo(() => product_gallery_items
        .filter((item) => {
        var _a;
        return ((_a = item.product_gallery_sizes) === null || _a === void 0 ? void 0 : _a.filter((size) => { var _a, _b; return ((_a = size.product) === null || _a === void 0 ? void 0 : _a.id) && ((_b = size.product_gallery_rooms) === null || _b === void 0 ? void 0 : _b.filter((room) => room.images.length > 0).length) > 0; }).length) > 0;
    })
        .map((item) => (Object.assign(Object.assign({}, item), { product_gallery_sizes: item.product_gallery_sizes
            .filter((size) => { var _a, _b; return ((_a = size.product) === null || _a === void 0 ? void 0 : _a.id) && ((_b = size.product_gallery_rooms) === null || _b === void 0 ? void 0 : _b.filter((room) => room.images.length > 0).length) > 0; })
            .map((size) => (Object.assign(Object.assign({}, size), { product_gallery_rooms: size.product_gallery_rooms.filter((room) => room.images.length > 0) }))) }))), [product_gallery_items]);
    const [state, setState] = useCommonReducer('product_gallery', {
        slideIndex: 0,
        itemId: items[0].id,
        selectedRoom: items[0].product_gallery_sizes[0].product_gallery_rooms[0].room,
        imageHeight: `${jQuery(window).height() - 100}px`,
        filterHeight: `${jQuery(window).height() - 150}px`,
        filterDrawerOpen: mobile,
        roomsDrawerOpen: mobile,
        fullscreenDrawerOpen: false,
        galleryWidth: 0,
        compare: {
            active: 'first',
            first: {
                item: items === null || items === void 0 ? void 0 : items[0],
                size: (_b = (_a = items === null || items === void 0 ? void 0 : items[0]) === null || _a === void 0 ? void 0 : _a.product_gallery_sizes) === null || _b === void 0 ? void 0 : _b[0],
                room: (_e = (_d = (_c = items === null || items === void 0 ? void 0 : items[0]) === null || _c === void 0 ? void 0 : _c.product_gallery_sizes) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.product_gallery_rooms[0],
                selectedSize: (_h = (_g = (_f = items === null || items === void 0 ? void 0 : items[0]) === null || _f === void 0 ? void 0 : _f.product_gallery_sizes) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.size,
            },
            second: null,
        },
    });
    const compare = useMemo(() => state.compare, [state.compare]);
    const selected_item = useMemo(() => { var _a, _b; return (compare.active === 'first' ? (_a = compare.first) === null || _a === void 0 ? void 0 : _a.item : (_b = compare.second) === null || _b === void 0 ? void 0 : _b.item); }, [compare]);
    const firstRoom = useMemo(() => { var _a; return (_a = compare.first) === null || _a === void 0 ? void 0 : _a.room; }, [(_j = compare.first) === null || _j === void 0 ? void 0 : _j.room]);
    const secondRoom = useMemo(() => { var _a; return (_a = compare.second) === null || _a === void 0 ? void 0 : _a.room; }, [(_k = compare.second) === null || _k === void 0 ? void 0 : _k.room]);
    const slideIndex = state.slideIndex;
    const rooms = useMemo(() => {
        var _a, _b, _c, _d, _e, _f;
        const rooms = DistinctFrom((_f = (_c = (_b = (_a = compare[compare.active]) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b.product_gallery_rooms) !== null && _c !== void 0 ? _c : (_e = (_d = compare[compare.active === 'first' ? 'second' : 'first']) === null || _d === void 0 ? void 0 : _d.size) === null || _e === void 0 ? void 0 : _e.product_gallery_rooms) !== null && _f !== void 0 ? _f : [], (room) => room.room.id).reduce((prev, current) => {
            if (!prev[current.room.type]) {
                prev[current.room.type] = [];
            }
            prev[current.room.type].push(Object.assign(Object.assign({}, current.room), { images: current.images, images_thumbnail: current.images_thumbnail }));
            return prev;
        }, {});
        for (const type in rooms) {
            rooms[type] = rooms[type].sort((a, b) => a.style.localeCompare(b.style));
        }
        return rooms;
    }, [compare]);
    const setSlideIndex = useCallback((index) => setState((currentState) => {
        currentState.slideIndex = index;
    }), [setState]);
    const handleKeyDown = useCallback((event) => {
        if (event.key === 'ArrowRight') {
            setSlideIndex(Math.min(slideIndex + 1, ((firstRoom === null || firstRoom === void 0 ? void 0 : firstRoom.images.length) || 0) - 1));
        }
        else if (event.key === 'ArrowLeft') {
            setSlideIndex(Math.max(slideIndex - 1, 0));
        }
    }, [slideIndex, setSlideIndex, firstRoom]);
    const handleItemChange = useCallback((itemId) => setState((currentState) => {
        var _a, _b, _c, _d;
        const currentComparedCard = currentState.compare[currentState.compare.active];
        const otherComparedCard = currentState.compare[currentState.compare.active === 'first' ? 'second' : 'first'];
        let selectedSize = (_a = currentComparedCard === null || currentComparedCard === void 0 ? void 0 : currentComparedCard.selectedSize) !== null && _a !== void 0 ? _a : otherComparedCard === null || otherComparedCard === void 0 ? void 0 : otherComparedCard.selectedSize;
        currentState.itemId = itemId;
        const item = items.find((item) => item.id === currentState.itemId);
        const size = (_b = item === null || item === void 0 ? void 0 : item.product_gallery_sizes.find((size) => size.size.id === (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.id))) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.product_gallery_sizes[0];
        const room = (_c = size === null || size === void 0 ? void 0 : size.product_gallery_rooms.find((room) => { var _a; return room.room.id === ((_a = currentState.selectedRoom) === null || _a === void 0 ? void 0 : _a.id); })) !== null && _c !== void 0 ? _c : size === null || size === void 0 ? void 0 : size.product_gallery_rooms[0];
        selectedSize = (_d = size === null || size === void 0 ? void 0 : size.size) !== null && _d !== void 0 ? _d : selectedSize;
        currentState.compare[currentState.compare.active] = {
            selectedSize,
            item,
            size,
            room,
        };
        currentState.filterDrawerOpen = false;
    }), [items, setState]);
    const handleSizeChange = useCallback((type, selectedSize) => setState((currentState) => {
        var _a, _b;
        const selectedCard = currentState.compare[type];
        if (!selectedCard)
            return;
        const newSelectedSize = (_a = selectedCard.item) === null || _a === void 0 ? void 0 : _a.product_gallery_sizes.find((size) => size.size.id === selectedSize.id);
        const newRoom = (_b = newSelectedSize === null || newSelectedSize === void 0 ? void 0 : newSelectedSize.product_gallery_rooms.find((room) => { var _a; return room.room.id === ((_a = currentState.selectedRoom) === null || _a === void 0 ? void 0 : _a.id); })) !== null && _b !== void 0 ? _b : newSelectedSize === null || newSelectedSize === void 0 ? void 0 : newSelectedSize.product_gallery_rooms[0];
        selectedCard.selectedSize = selectedSize;
        selectedCard.size = newSelectedSize;
        selectedCard.room = newRoom;
        currentState.filterDrawerOpen = false;
    }), [setState]);
    const handleRoomChange = useCallback((room) => {
        if (!desktop) {
            const root = jQuery(rootElement.current);
            jQuery([document.documentElement, document.body]).animate({
                scrollTop: root.offset().top - 150,
            });
        }
        setState((currentState) => {
            var _a, _b, _c, _d;
            currentState.selectedRoom = room;
            if ((_a = currentState.compare.first) === null || _a === void 0 ? void 0 : _a.size) {
                currentState.compare.first.room =
                    (_b = currentState.compare.first.size.product_gallery_rooms.find((r) => r.room.id === room.id)) !== null && _b !== void 0 ? _b : currentState.compare.first.size.product_gallery_rooms[0];
            }
            if ((_c = currentState.compare.second) === null || _c === void 0 ? void 0 : _c.size) {
                currentState.compare.second.room =
                    (_d = currentState.compare.second.size.product_gallery_rooms.find((r) => r.room.id === room.id)) !== null && _d !== void 0 ? _d : currentState.compare.second.size.product_gallery_rooms[0];
            }
            currentState.slideIndex = 0;
            currentState.roomsDrawerOpen = false;
        });
    }, [desktop, setState]);
    const toggleFullscreen = useCallback(() => {
        setState((previousState) => {
            previousState.fullscreenDrawerOpen = !previousState.fullscreenDrawerOpen;
        });
    }, [setState]);
    const handleFilterDrawerToggle = useCallback((active) => {
        setState((currentState) => {
            if (active !== undefined) {
                currentState.compare.active = active;
            }
            currentState.filterDrawerOpen = !currentState.filterDrawerOpen;
        });
    }, [setState]);
    const handleFilterDrawerClose = useCallback((event) => {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setState((currentState) => {
            currentState.filterDrawerOpen = false;
        });
    }, [setState]);
    const handleFilterDrawerOpen = useCallback((event) => {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setState((currentState) => {
            currentState.filterDrawerOpen = true;
        });
    }, [setState]);
    const handleToggleRoomsDrawer = useCallback((event) => {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setState((currentState) => {
            currentState.roomsDrawerOpen = !currentState.roomsDrawerOpen;
        });
    }, [setState]);
    const handleToggleCompare = useCallback((active) => {
        setState((currentState) => {
            currentState.compare.active = active !== null && active !== void 0 ? active : 'second';
            currentState.filterDrawerOpen = true;
        });
    }, [setState]);
    const closeCompare = useCallback(() => {
        setState((currentState) => {
            currentState.compare.active = 'first';
            currentState.filterDrawerOpen = false;
            currentState.compare.second = null;
        });
    }, [setState]);
    const breakpoint = useMemo(() => (desktop ? 'desktop' : 'mobile'), [desktop]);
    const compareActive = useMemo(() => compare.active !== null, [compare.active]);
    useEffect(() => {
        function handleResize() {
            setState((currentState) => {
                var _a, _b;
                let windowHeight = jQuery(window).height() - (desktop ? 150 : 400);
                const root = jQuery(rootElement.current);
                const galleryContent = root.find('.gallery-section');
                const galleryContentWidth = (_a = galleryContent.width()) !== null && _a !== void 0 ? _a : windowHeight;
                const galleryContentSize = galleryContent
                    .find('>*:not(.image-wrapper)')
                    .toArray()
                    .map((el) => { var _a; return (_a = jQuery(el).outerHeight(true)) !== null && _a !== void 0 ? _a : 0; })
                    .reduce((pres, current) => pres + current, 0);
                const filterContent = root.find('.filter-section');
                const filterContentSize = filterContent
                    .find('>*:not(.filter-wrapper)')
                    .toArray()
                    .map((el) => { var _a; return (_a = jQuery(el).outerHeight(true)) !== null && _a !== void 0 ? _a : 0; })
                    .reduce((pres, current) => pres + current, 10);
                const overAllSize = galleryContentWidth + galleryContentSize;
                currentState.imageHeight = `${galleryContentWidth}px`;
                currentState.filterHeight = desktop ? `${overAllSize - filterContentSize}px` : 'auto';
                currentState.galleryWidth = (_b = galleryContent.width()) !== null && _b !== void 0 ? _b : 0;
            });
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleResize);
        };
    }, [setState, desktop, compareActive]);
    const filterComponent = (_jsx(ProductGalleryFiltersSection, { onItemChange: handleItemChange, product_gallery_items: items, selected_item: selected_item, "aria-label": 'Product filters' }));
    const iOS = useMemo(() => typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent), []);
    const filterMaxHeight = useMemo(() => { var _a; return ((_a = jQuery(window).height()) !== null && _a !== void 0 ? _a : 700) * 0.8; }, []);
    return (_jsxs("div", Object.assign({ ref: rootElement, className: 'page-content', style: { '--image-height': state.imageHeight, '--filter-height': state.filterHeight }, onKeyDown: handleKeyDown, role: 'region', "aria-label": 'Product gallery' }, { children: [heading && _jsx("h1", Object.assign({ className: 'page-title' }, { children: heading })), _jsx(ZoomProductGalleryGallerySection, { firstRoom: firstRoom, secondRoom: secondRoom, onRoomChange: handleRoomChange, breakpoint: breakpoint, toggleCompare: handleToggleCompare, galleryWidth: state.galleryWidth, slideIndex: slideIndex, setSlideIndex: setSlideIndex, toggleFullscreen: toggleFullscreen, fullscreen: state.fullscreenDrawerOpen, ref: zoomSwiperElement, "aria-label": 'Zoomed product gallery view' }), _jsxs("div", Object.assign({ className: clsx('contents', breakpoint) }, { children: [desktop && filterComponent, _jsx(ProductGalleryGallerySection, { breakpoint: breakpoint, firstRoom: firstRoom, secondRoom: secondRoom, selectedRoom: state.selectedRoom || (firstRoom !== null && firstRoom !== void 0 ? firstRoom : secondRoom).room, slideIndex: slideIndex, setSlideIndex: setSlideIndex, toggleFullscreen: toggleFullscreen, toggleRoomsDrawer: handleToggleRoomsDrawer, ref: mainSwiperElement, "aria-label": 'Product gallery images' }), _jsxs("div", Object.assign({ className: 'products-section', role: 'region', "aria-label": 'Product comparison section' }, { children: [_jsx(ProductCardItem, { type: 'first', onSizeChange: handleSizeChange, product_gallery_items: items, galleryItem: (_l = compare.first) === null || _l === void 0 ? void 0 : _l.item, gallerySize: (_m = compare.first) === null || _m === void 0 ? void 0 : _m.size, selectedSize: (_o = compare.first) === null || _o === void 0 ? void 0 : _o.selectedSize, breakpoint: breakpoint, onFilterDrawerToggle: handleFilterDrawerToggle, active: compare.active === 'first', "aria-label": 'First product' }), _jsx(ProductCardItem, { type: 'second', onSizeChange: handleSizeChange, product_gallery_items: items, galleryItem: (_p = compare.second) === null || _p === void 0 ? void 0 : _p.item, gallerySize: (_q = compare.second) === null || _q === void 0 ? void 0 : _q.size, selectedSize: (_r = compare.second) === null || _r === void 0 ? void 0 : _r.selectedSize, breakpoint: breakpoint, onFilterDrawerToggle: handleFilterDrawerToggle, active: compare.active === 'second', closeCompare: closeCompare, "aria-label": 'Second product' })] })), mobile && (_jsxs(SwipeableDrawer, Object.assign({ anchor: 'bottom', open: state.filterDrawerOpen, onClose: handleFilterDrawerClose, onOpen: handleFilterDrawerOpen, disableBackdropTransition: !iOS, disableDiscovery: iOS, ModalProps: {
                            keepMounted: true,
                            'aria-label': 'Filter options',
                        }, swipeAreaWidth: 100, PaperProps: {
                            sx: {
                                maxHeight: filterMaxHeight,
                                minHeight: 100,
                                borderTopLeftRadius: 8,
                                borderTopRightRadius: 8,
                                width: '100%',
                            },
                            'aria-label': 'Product filter drawer',
                        } }, { children: [_jsx(DrawerHeader, { children: _jsxs(IconButton, Object.assign({ onClick: () => handleFilterDrawerToggle(), color: 'secondary', "aria-label": state.filterDrawerOpen ? 'Close filter drawer' : 'Open filter drawer' }, { children: [state.filterDrawerOpen ? _jsx(ExpandMoreIcon, {}) : _jsx(ExpandLessIcon, {}), _jsx(ScreenReaderOnly, { children: state.filterDrawerOpen ? 'Close filter drawer' : 'Open filter drawer' })] })) }), _jsx("div", Object.assign({ className: 'sb-product-gallery drawer' }, { children: _jsx("div", Object.assign({ className: clsx('contents', breakpoint) }, { children: filterComponent })) }))] }))), _jsxs(Drawer, Object.assign({ anchor: 'left', open: state.roomsDrawerOpen, onClose: handleToggleRoomsDrawer, "aria-label": 'Room selection drawer' }, { children: [_jsx(DrawerHeader, Object.assign({ sx: { top: 0, right: 0 } }, { children: _jsxs(IconButton, Object.assign({ onClick: handleToggleRoomsDrawer, color: 'secondary', "aria-label": 'Close room selection' }, { children: [_jsx(CloseIcon, {}), _jsx(ScreenReaderOnly, { children: "Close room selection" })] })) })), _jsx("div", Object.assign({ className: 'sb-product-gallery drawer' }, { children: _jsx("div", Object.assign({ className: clsx('contents', breakpoint) }, { children: _jsx(ProductGalleryRoomsSection, { compare: compare, rooms: rooms, onRoomChange: handleRoomChange, selectedroom: state.selectedRoom, breakpoint: breakpoint, "aria-label": 'Room selection options' }) })) }))] }))] }))] })));
}
function ProductGallerySection(props) {
    return (_jsx(AppProvider, { children: _jsx(SbThemeProvider, { children: _jsx(ProductGallery, Object.assign({}, props)) }) }));
}
export default function LoadProductGallerySection(element, item, algolia) {
    const root = createRoot(element);
    root.render(_jsx(ProductGallerySection, Object.assign({}, item, { algoliaRender: algolia.render, elementData: Object.assign(Object.assign({}, element.dataset), { sampleShow: element.dataset.sampleShow === 'true', sampleShowPrice: element.dataset.sampleShowPrice === 'true' }) })));
}
